(function ($) {

    $('.filter-dropdown .dropdown-top-box').on('click', function () {
        $(this).parent().toggleClass('active');
        $(this).parent().siblings().not('.tab-content').removeClass('active');
    });
    $('.dropdown-select').on('click', function () {
        $(this).toggleClass('selected');
    });

    $('body').on('click', function (e) {
        if ($(e.target).closest('.filter-dropdown').length === 0) {
            $('.filter-dropdown').removeClass('active');
        }
    });
})(jQuery);